import { useTranslation } from 'react-i18next';
import { toast } from '@ui/components';

import { useGenerateReport, ReportType } from './use-generate-report';

export const useReportsPanel = () => {
  const { t } = useTranslation();

  const allExpensesSummaryReportController = useGenerateReport({
    reportType: ReportType.EXPENSES_SUMMARY,
    onDownloadSuccess: () => {
      toast.success(t('FILES_REPORTS.REPORTS.ALL_EXPENSES_SUMMARY_SUCCESS'));
    },
  });

  const allCostCentersSummaryReportController = useGenerateReport({
    reportType: ReportType.COST_CENTERS_SUMMARY,
    onDownloadSuccess: () => {
      toast.success(t('FILES_REPORTS.REPORTS.ALL_COST_CENTERS_SUMMARY_SUCCESS'));
    },
  });

  return {
    allCostCentersSummaryReportController,
    allExpensesSummaryReportController,
  };
};
